import { ReactElement, useState, useEffect, ChangeEvent, KeyboardEvent } from "react";
import { getTitle } from "../../shared/utils";
import { PageNumberData } from "../../shared/types";
import { PageNumber } from "@bronte/common";
import "./styles.scss";

export const NavigationBar = ({
  viewerApi,
  prevItem,
  nextItem,
  currentItem,
  pageNumber,
  shouldNavigateByPage,
}: any): ReactElement => {
  const [targetPageNumber, setTargetPageNumber] = useState(pageNumber);
  const [pageNumberIndex, setPageNumberIndex] = useState(0);

  useEffect(() => {
    setTargetPageNumber(pageNumber);
  }, [pageNumber]);

  const handleEnter = (event: KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === "Enter") {
      const { screenId, dataId } = getPageNumberMap(targetPageNumber) || {};

      if (screenId && dataId) {
        viewerApi.route(screenId, { dataId });

        if (shouldNavigateByPage) {
          const pageNumberList = getPageNumbersByScreen(screenId);
          const pageNumberIndex = getCurrentPageIndex(pageNumberList, targetPageNumber);
          setPageNumberIndex(Number(pageNumberIndex));
        }
      } else {
        setTargetPageNumber(pageNumber);
        alert(`Dev Shell: ${targetPageNumber} is not a valid page number.`);
        console.error(`Dev Shell: ${targetPageNumber} is not a valid page number.`);
      }
    }
  };

  const getPageNumberMap = (pageNumber: string): PageNumberData | undefined => {
    const pageNumbers = window.pageNumbers;

    for (const screenId in pageNumbers) {
      for (const item of pageNumbers[screenId]) {
        if (item.dataId && item.pageNumber === pageNumber) {
          return {
            screenId,
            dataId: item.dataId,
          };
        }
      }
    }

    return;
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const value = event.target.value;
    setTargetPageNumber(value);
  };

  const getCurrentPageIndex = (pageNumberList: PageNumber[], pageNumber: string): number => {
    const pageNumberIndex = pageNumberList.findIndex(
      (obj: PageNumber) => obj.pageNumber === pageNumber,
    );
    return pageNumberIndex;
  };

  const navigateToSlate = (
    currIndex: number,
    pageNumberArr: PageNumber[],
    elementId: string,
  ): void => {
    const currDataId = pageNumberArr[currIndex]?.dataId;
    if (currDataId) {
      viewerApi.route(currentItem, { dataId: currDataId });
      setPageNumberIndex(currIndex);
    } else {
      viewerApi.route(elementId);
      setPageNumberIndex(0);
    }
  };

  const getPageNumbersByScreen = (elementId: string): PageNumber[] => {
    const pageNumbers = window.pageNumbers && window.pageNumbers[elementId];
    return (shouldNavigateByPage && pageNumbers) || [];
  };

  const onNext = (): void => {
    const pageNumberArr = getPageNumbersByScreen(currentItem);
    let currIndex = pageNumberIndex || 0;
    const pageNumberArrLen = pageNumberArr.length;

    if (shouldNavigateByPage && pageNumberArrLen > 1 && currIndex !== pageNumberArrLen - 1) {
      currIndex = getCurrentPageIndex(pageNumberArr, targetPageNumber);
      navigateToSlate(currIndex + 1, pageNumberArr, nextItem.elementId);
      return;
    }

    if (nextItem?.elementId) {
      viewerApi.route(nextItem.elementId);
      setPageNumberIndex(0);
    }
  };

  const onPrev = (): void => {
    const pageNumberArr = getPageNumbersByScreen(currentItem);
    let currIndex = pageNumberIndex || 0;

    if (shouldNavigateByPage && pageNumberArr?.length > 1 && currIndex > 0) {
      currIndex = getCurrentPageIndex(pageNumberArr, targetPageNumber);
      navigateToSlate(currIndex - 1, pageNumberArr, prevItem.elementId);
      return;
    }

    if (prevItem?.elementId) {
      const pageNumberArr = getPageNumbersByScreen(prevItem.elementId);
      const pageNumberArrLen = pageNumberArr.length;

      if (shouldNavigateByPage && pageNumberArrLen > 1) {
        viewerApi.route(prevItem.elementId, {
          dataId: pageNumberArr[pageNumberArrLen - 1]?.dataId,
        });
        const currIndex = getCurrentPageIndex(pageNumberArr, targetPageNumber);
        setPageNumberIndex(currIndex - 1);
      } else {
        viewerApi.route(prevItem.elementId);
        setPageNumberIndex(0);
      }
    }
  };

  return (
    <div className="navigation-bar">
      <div className="navigation-button previous-button">
        {prevItem && (
          <button onClick={onPrev}>
            ❮{" "}
            <span>{!!prevItem?.configurationFields && getTitle(prevItem.configurationFields)}</span>
          </button>
        )}
      </div>
      <input
        type="text"
        className="page-number"
        value={targetPageNumber}
        onChange={handleInputChange}
        onKeyUp={handleEnter}
      />
      <div className="navigation-button next-button">
        {nextItem && (
          <button onClick={onNext}>
            <span>{!!nextItem?.configurationFields && getTitle(nextItem.configurationFields)}</span>{" "}
            ❯
          </button>
        )}
      </div>
    </div>
  );
};
